import React, { useEffect, useState, useCallback } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import QuestionIcon from "@mui/icons-material/HelpOutline";

import "./Select.css";

const CustomSelect = (props) => {
  const { t } = useTranslation();

  const [selection, setSelection] = useState(props.initialValue);
  const menuPortalTarget = typeof document !== "undefined" ? document.body : null;

  useEffect(() => {
    if (props.initialValue) {
      handleChange(props.initialValue, "", false);
    }
    //eslint-disable-next-line
  }, []);

  //eslint-disable-next-line
  const handleChange = useCallback((selectedoption, action, dontFire = false) => {
    if (!props.isMulti) {
      if (!selectedoption) {
        setSelection(null);
        props.onInput(props.id, "", true);
        if (props.fireChange && !dontFire) {
          props.fireChange("");
        }
        return;
      }
      setSelection(selectedoption);
      props.onInput(props.id, selectedoption.value, true);

      if (props.fireChange && !dontFire) {
        props.fireChange(selectedoption.value);
      }
    } else {
      if (selectedoption) {
        // const sortedSelections = sortArrayByLabel(selectedoption);
        setSelection(selectedoption);
        props.onInput(
          props.id,
          selectedoption.map((item) => item.value),
          true,
        );
        if (props.fireChange && !dontFire) {
          props.fireChange(selectedoption.map((item) => item.value));
        }
      } else {
        props.onInput(props.id, [], false);
        setSelection([]);
      }
    }
  });

  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 99999999,
    }),
  };
  return (
    <div className={`select-input ${props.noMargin ? "no-margin" : ""}`} style={{ ...props.style }}>
      {props.label && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
            columnGap: "10px",
          }}
        >
          <label htmlFor={props.id}>{props.label}</label>

          {props.description && (
            <Tooltip title={<span style={{ whiteSpace: "pre-line" }}>{props.description}</span>}>
              <QuestionIcon sx={{ color: "gray", width: "20px", height: "auto", marginBottom: "0.5rem" }} />
            </Tooltip>
          )}
        </div>
      )}

      <Select
        id={props.id}
        isDisabled={props.disabled}
        isSearchable={true}
        isClearable={props.isClearable}
        value={selection}
        isMulti={props.isMulti}
        onChange={handleChange}
        options={props.options}
        placeholder={t("select")}
        styles={selectStyles}
        onKeyDown={props.onKeyDown}
        menuPortalTarget={menuPortalTarget}
        menuPosition="fixed"
        menuShouldScrollIntoView={false}
      />
    </div>
  );
};

export default CustomSelect;
